"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Body = Body;
exports.Caption = Caption;
exports.Heading4 = exports.Heading3 = exports.Heading2 = exports.Heading1 = void 0;
exports.Lead = Lead;
exports.SmallCaption = SmallCaption;
exports.Subheading1 = Subheading1;
exports.Subheading2 = Subheading2;
exports.Super2 = exports.Super1 = void 0;
var _classnames = _interopRequireDefault(require("classnames"));
var React = _interopRequireWildcard(require("react"));
var _classes = require("../../common/classes");
var _helpers = require("../../common/helpers");
var _excluded = ["className", "muted", "tagName"],
  _excluded2 = ["className", "muted", "tagName"],
  _excluded3 = ["bold", "className", "intent", "inverted", "muted", "semiBold", "tagName"],
  _excluded4 = ["bold", "className", "muted", "semiBold", "tagName"],
  _excluded5 = ["bold", "className", "intent", "inverted", "muted", "semiBold", "tagName"],
  _excluded6 = ["bold", "className", "intent", "inverted", "muted", "semiBold", "tagName"];
/*
 * Copyright 2018 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
// Page headings are set in this style.
var Heading1 = (0, _helpers.htmlElement)('h1', _classes.Classes.HEADING);

// Secondary headings are set in this style.
exports.Heading1 = Heading1;
var Heading2 = (0, _helpers.htmlElement)('h2', _classes.Classes.HEADING);

// Tertiary headings are set in this style.
exports.Heading2 = Heading2;
var Heading3 = (0, _helpers.htmlElement)('h3', _classes.Classes.HEADING);
exports.Heading3 = Heading3;
var Heading4 = (0, _helpers.htmlElement)('h4', _classes.Classes.HEADING);

// Used to show data in charts and other components with high emphasis.
exports.Heading4 = Heading4;
var Super1 = (0, _helpers.htmlElement)('div', _classes.Classes.SUPERHEADING1);

// Used to show data in charts and other components with lower emphasis.
exports.Super1 = Super1;
var Super2 = (0, _helpers.htmlElement)('div', _classes.Classes.SUPERHEADING2);

// Usages include primary navigation, primary/secondary buttons, and card titles.
exports.Super2 = Super2;
function Subheading1(_ref) {
  var className = _ref.className,
    muted = _ref.muted,
    tagName = _ref.tagName,
    props = _objectWithoutProperties(_ref, _excluded);
  var classes = (0, _classnames.default)(_defineProperty({}, _classes.Classes.TEXT_MUTED, muted), _classes.Classes.SUBHEADING1, className);
  var Component = (0, _helpers.htmlElement)(tagName || 'div', classes);
  return /*#__PURE__*/React.createElement(Component, props);
}

// Usages include input field titles, tertiary buttons and chips.
function Subheading2(_ref2) {
  var className = _ref2.className,
    muted = _ref2.muted,
    tagName = _ref2.tagName,
    props = _objectWithoutProperties(_ref2, _excluded2);
  var classes = (0, _classnames.default)(_defineProperty({}, _classes.Classes.TEXT_MUTED, muted), _classes.Classes.SUBHEADING2, className);
  var Component = (0, _helpers.htmlElement)(tagName || 'div', classes);
  return /*#__PURE__*/React.createElement(Component, props);
}

// Usages include paragraph text, navigation and input fields.

function Body(_ref3) {
  var bold = _ref3.bold,
    className = _ref3.className,
    intent = _ref3.intent,
    inverted = _ref3.inverted,
    muted = _ref3.muted,
    semiBold = _ref3.semiBold,
    tagName = _ref3.tagName,
    props = _objectWithoutProperties(_ref3, _excluded3);
  var classes = (0, _classnames.default)(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, _classes.Classes.INVERTED, inverted), _classes.Classes.TEXT_MUTED, muted), _classes.Classes.TEXT_BOLD, bold), _classes.Classes.TEXT_SEMI_BOLD, semiBold), _classes.Classes.intentClass(intent), intent), _classes.Classes.BODY_TEXT, className);
  var Component = (0, _helpers.htmlElement)(tagName || 'div', classes);
  return /*#__PURE__*/React.createElement(Component, props);
}

// Typical usage would be for paragraph text where there is not much other copy present,
// or as an introduction paragraph with further text.
// tslint:disable-next-line:no-empty-interface

function Lead(_ref4) {
  var bold = _ref4.bold,
    className = _ref4.className,
    muted = _ref4.muted,
    semiBold = _ref4.semiBold,
    tagName = _ref4.tagName,
    props = _objectWithoutProperties(_ref4, _excluded4);
  var classes = (0, _classnames.default)(_defineProperty(_defineProperty(_defineProperty({}, _classes.Classes.TEXT_MUTED, muted), _classes.Classes.TEXT_BOLD, bold), _classes.Classes.TEXT_SEMI_BOLD, semiBold), _classes.Classes.LEAD, className);
  var Component = (0, _helpers.htmlElement)(tagName || 'div', classes);
  return /*#__PURE__*/React.createElement(Component, props);
}
function Caption(_ref5) {
  var bold = _ref5.bold,
    className = _ref5.className,
    intent = _ref5.intent,
    inverted = _ref5.inverted,
    muted = _ref5.muted,
    semiBold = _ref5.semiBold,
    tagName = _ref5.tagName,
    props = _objectWithoutProperties(_ref5, _excluded5);
  var classes = (0, _classnames.default)(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, _classes.Classes.INVERTED, inverted), _classes.Classes.TEXT_MUTED, muted), _classes.Classes.TEXT_BOLD, bold), _classes.Classes.TEXT_SEMI_BOLD, semiBold), _classes.Classes.intentClass(intent), intent), _classes.Classes.CAPTION, className);
  var Component = (0, _helpers.htmlElement)(tagName || 'div', classes);
  return /*#__PURE__*/React.createElement(Component, props);
}

// Used for displaying smaller text to improve data density in tight spaces

function SmallCaption(_ref6) {
  var bold = _ref6.bold,
    className = _ref6.className,
    intent = _ref6.intent,
    inverted = _ref6.inverted,
    muted = _ref6.muted,
    semiBold = _ref6.semiBold,
    tagName = _ref6.tagName,
    props = _objectWithoutProperties(_ref6, _excluded6);
  var classes = (0, _classnames.default)(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, _classes.Classes.INVERTED, inverted), _classes.Classes.TEXT_MUTED, muted), _classes.Classes.TEXT_BOLD, bold), _classes.Classes.TEXT_SEMI_BOLD, semiBold), _classes.Classes.intentClass(intent), intent), _classes.Classes.SMALLCAPTION, className);
  var Component = (0, _helpers.htmlElement)(tagName || 'div', classes);
  return /*#__PURE__*/React.createElement(Component, props);
}